// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardForm-Action_cls1__l1ro5","cls2":"VeloCardForm-Action_cls2__PBDNf VeloCardForm-Action_cls1__l1ro5"};